import {graphqlRequest} from '@shopify/cli-kit/node/api/graphql';
import {AbortError} from '@shopify/cli-kit/node/error';
import {Logger, outputInfo} from '@shopify/cli-kit/node/output';

import {errorHandler, Header} from '../utils/utils.js';

import type {DeploymentConfig} from './types.js';
import {
  DeploymentCancelQuery,
  DeploymentCancelQueryData,
  DeploymentCancelResponse,
} from './graphql/deployment-cancel.js';

interface DeploymentCancelOptions {
  config: DeploymentConfig;
  deploymentId: string;
  reason: string;
  logger: Logger;
}

export async function deploymentCancel(
  options: DeploymentCancelOptions,
): Promise<DeploymentCancelResponse> {
  const {config, deploymentId, reason, logger} = options;

  const variables = {
    deploymentId,
    reason,
  };

  try {
    const response: DeploymentCancelQueryData = await graphqlRequest({
      query: DeploymentCancelQuery,
      api: 'Oxygen',
      url: `${config.deploymentUrl}/api/v2/admin/graphql`,
      token: config.deploymentToken.accessToken,
      variables,
      addedHeaders: {
        [Header.OxygenNamespaceHandle]: config.deploymentToken.namespace,
      },
    });

    if (response.deploymentCancel.userErrors.length >= 1) {
      throw new AbortError(
        response.deploymentCancel.userErrors[0]?.message || '',
      );
    }
    outputInfo(`Deployment with id ${deploymentId} cancelled.`, logger);

    return response.deploymentCancel;
  } catch (error) {
    errorHandler(error);

    throw error;
  }
}
